import React from 'react';

import EntityTag from 'shiftNotes/components/EntityTag/EntityTag';
import { OverviewUrgencyItem } from 'dashboard/types';
import { getUrgencyColors } from 'dashboard/urgencyColors';

import * as Styled from 'dashboard/styles/Overview.style';
import * as Text from 'theme/components/Text.style';

interface UrgencyCardProps {
  data: OverviewUrgencyItem[] | undefined;
  isLoading: boolean;
}

export default function UrgencyCard({
  data,
  isLoading,
}: UrgencyCardProps): JSX.Element {
  return (
    <Styled.StatRowsContainer>
      {isLoading || !data ? (
        <Styled.UrgencyStatRow>
          <Text.H3>–</Text.H3>
        </Styled.UrgencyStatRow>
      ) : (
        data.map((item) => (
          <Styled.UrgencyStatRow key={item.category_key}>
            <Text.H3>{item.percentage}%</Text.H3>
            <EntityTag
              extractionClass="urgency"
              category={item.category}
              description={item.category_description}
              colors={getUrgencyColors(item.category_key) ?? undefined}
            />
          </Styled.UrgencyStatRow>
        ))
      )}
    </Styled.StatRowsContainer>
  );
}
